import { render, staticRenderFns } from "./ShareEmailComponent.vue?vue&type=template&id=208d1a1a&scoped=true"
import script from "./ShareEmailComponent.vue?vue&type=script&lang=js"
export * from "./ShareEmailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d1a1a",
  null
  
)

export default component.exports